export const COMMUNITY_BUNDLE_TYPES = {
  NONE: 'NONE',
  STANDARD: 'STANDARD',
  ADVANCED: 'ADVANCED',
  PREMIUM: 'PREMIUM',
};

export const COMMUNITY_BUNDLE_TYPE_DROPDOWN_OPTIONS = [
  {
    key: '1',
    value: 'STANDARD',
    text: 'msg_standard',
  },
  {
    key: '2',
    value: 'ADVANCED',
    text: 'msg_advanced',
  },
  {
    key: '3',
    value: 'PREMIUM',
    text: 'msg_premium',
  },
];
